import * as React from "react";
import {Attributes, Component} from "react";
import {Collapse} from "react-bootstrap";

interface PropertyContainerProps extends Attributes {
    widgetSelected: boolean;
    name: string;
    label: string;
    animateExpandOnMount: boolean;
    isEnabled: boolean;
}
interface PropertyContainerDefaultProps {
    isEnabled: boolean;
}

interface PropertyContainerState {
    collapsed: boolean;
    previousWidgetSelected: boolean;
}

class PropertyContainerComponent extends Component<PropertyContainerProps,PropertyContainerState> {
    static defaultProps: PropertyContainerDefaultProps = {
        isEnabled: true
    }
    static getDerivedStateFromProps(props: PropertyContainerProps, state: PropertyContainerState) {
        if(props.widgetSelected !== state.previousWidgetSelected) {
            return {collapsed: props.widgetSelected, previousWidgetSelected: props.widgetSelected};
        }
        return null;
    }

    constructor(props: PropertyContainerProps) {
        super(props);

        this.state = {
            collapsed: props.widgetSelected,
            previousWidgetSelected: props.widgetSelected,
        };
    }

    toggleCollapse = () => {
        this.setState({collapsed: !this.state.collapsed});
    }

    componentDidMount() {
        if(this.props.animateExpandOnMount) {
            setTimeout(() => {
                this.setState({
                    collapsed: false
                });
            }, 100);
        }
    }

    render () {
        const {children, name, label, isEnabled} = this.props;
        const {collapsed} = this.state;
        // Do we actually need this or are we doing the job of react-bootstrap?
        const collapsedClass = collapsed ? "collapsible collapsed" : "collapsible";

        return (
            <fieldset className={`${name}-properties`}>
                <legend
                    className={`${collapsedClass} ${isEnabled ? "" : "disabled"}`}
                    onClick={this.toggleCollapse}
                >
                    {label}
                </legend>
                <Collapse in={!collapsed && isEnabled} className={`${name}-properties-container zmags-input-control`}>
                    <div>
                        {children}
                    </div>
                </Collapse>
            </fieldset>
        );
    }
}

// noinspection JSUnusedGlobalSymbols
export {
    PropertyContainerComponent as default,
    PropertyContainerComponent,
};



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/toolbox/PropertyContainerComponent.tsx